
import {config} from '/config.js'

export default {
    name: "Notice",
    data (){
        return{
            copyright: config.copyright,
            logo: config.whiteLogo,
          isShown: false
        }
    },
    methods:{
        hideNotice (){
            this.isShown = false
        }
    }

}
